import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function MsLightningGreySvg({ classNameProps, width, height }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 100 100'
      fill='none'
    >
      <rect width='100' height='100' fill='none' />
      <path
        d='M53.7709 13.8707L27.7831 40.4713C24.658 43.6723 25.8093 49.0255 29.9213 50.6811L45.7114 57.0277L38.6388 81.8072C37.3229 86.3878 43.1345 89.5335 46.2048 85.9463L72.9053 54.9858C75.6467 51.7849 74.5501 46.818 70.6575 45.1071L54.1547 37.8775L61.0628 18.4513C62.6528 13.9811 57.1153 10.4491 53.7709 13.8707Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default MsLightningGreySvg;
